import React from 'react';
import { clsx } from 'clsx';

import { MochiRadioItem } from './mochi-radio-item';
import styles from './mochi-radio-item.module.sass';
interface MochiRadioItemGroupProps {
  list: { id: string; label: string; content: React.ReactNode }[];
  value: string | null;
  name: string;
  onChange: (selectedId: string) => void;
  className?: string;
  spacing?: string | number | undefined;
}

export const MochiRadioItemGroup = ({
  list,
  value,
  name,
  onChange,
  className,
  spacing = '0.5rem',
}: MochiRadioItemGroupProps) => {
  return (
    <div
      className={clsx(styles['mochi-radio-item-group'], className)}
      style={{ gap: spacing }}
    >
      {list.map(({ id, label, content }) => {
        return (
          <MochiRadioItem
            key={id}
            id={id}
            isChecked={id === value}
            label={label}
            content={content}
            name={name}
            onClick={() => onChange(id)}
          />
        );
      })}
    </div>
  );
};
